const getTopPlaysLeague = (athlete = {}) => String(
  athlete?._top_play_source_league || athlete?.league || "popular"
).trim().toLowerCase();

const shuffle = (items = [], random = Math.random) => {
  const shuffled = [...items];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const target = Math.floor(random() * (index + 1));
    [shuffled[index], shuffled[target]] = [shuffled[target], shuffled[index]];
  }
  return shuffled;
};

const getStableRandom = (athletes = []) => {
  const seedText = athletes.map((athlete) => [
    athlete?.athlete_id || athlete?.term_id || athlete?.name || "",
    athlete?.stat_key || "",
  ].join("|")).join(";");
  let seed = Array.from(seedText).reduce(
    (hash, character) => Math.imul(hash ^ character.charCodeAt(0), 16777619) >>> 0,
    2166136261
  );

  return () => {
    seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
    return seed / 4294967296;
  };
};

const mixTopPlaysAthletes = (athleteList = [], maximum = 24, random = null) => {
  const rows = Array.isArray(athleteList) ? athleteList : [];
  const representatives = [];
  const representedLeagues = new Set();
  const remaining = [];

  rows.forEach((athlete) => {
    const league = getTopPlaysLeague(athlete);
    if (representatives.length < 3 && !representedLeagues.has(league)) {
      representedLeagues.add(league);
      representatives.push(athlete);
      return;
    }
    remaining.push(athlete);
  });

  return [...representatives, ...shuffle(remaining, random || getStableRandom(rows))].slice(0, maximum);
};

module.exports = {
  getTopPlaysLeague,
  mixTopPlaysAthletes,
};
